(() => {
  const menu = document.querySelector('[data-mobile-nav]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');
  const setMenu = (open) => { if (!menu) return; menu.hidden = !open; toggle?.setAttribute('aria-expanded', String(open)); document.body.style.overflow = open ? 'hidden' : ''; };
  toggle?.addEventListener('click', () => setMenu(menu.hidden));
  close?.addEventListener('click', () => setMenu(false));
  menu?.addEventListener('click', (event) => { if (event.target === menu) setMenu(false); });

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-product-scroller]').forEach((scroller) => {
    const root = scroller.parentElement;
    const cards = [...scroller.querySelectorAll('.product-card')];
    const step = () => Math.max(scroller.clientWidth * .82, cards[0]?.clientWidth || 0);
    const move = (direction = 1) => {
      const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      if (!max) return;
      const next = scroller.scrollLeft + (step() * direction);
      const target = direction > 0
        ? (next >= max - 4 ? (scroller.scrollLeft >= max - 4 ? 0 : max) : next)
        : Math.max(0, next);
      scroller.scrollTo({ left: target, behavior: 'smooth' });
    };
    root?.querySelector('[data-scroll-left]')?.addEventListener('click', () => move(-1));
    root?.querySelector('[data-scroll-right]')?.addEventListener('click', () => move(1));
    if (reduced || cards.length < 2) return;
    let timer;
    const stop = () => window.clearInterval(timer);
    const start = () => { stop(); timer = window.setInterval(() => move(1), 4000); };
    ['mouseenter', 'focusin', 'touchstart'].forEach((event) => scroller.addEventListener(event, stop, { passive: true }));
    ['mouseleave', 'focusout', 'touchend'].forEach((event) => scroller.addEventListener(event, start, { passive: true }));
    start();
  });

  const reveal = document.querySelectorAll('[data-reveal]');
  reveal.forEach((item) => item.querySelectorAll(':scope > *').forEach((child, index) => child.style.setProperty('--reveal-delay', String(Math.min(index, 5) * 70) + 'ms')));
  if (reduced || !('IntersectionObserver' in window)) {
    reveal.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries, obs) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
    }), { threshold: .08 });
    reveal.forEach((item) => observer.observe(item));
  }

  const wordTargets = document.body.classList.contains('template-index')
    ? document.querySelectorAll('main h1, main h2')
    : [];
  wordTargets.forEach((heading) => {
    if (heading.dataset.wordReveal || heading.children.length) return;
    const words = heading.textContent.trim().split(/\s+/).filter(Boolean);
    if (!words.length) return;
    heading.dataset.wordReveal = 'true';
    heading.textContent = '';
    words.forEach((word, index) => {
      const span = document.createElement('span');
      span.className = 'word-reveal';
      span.style.setProperty('--word-delay', String(Math.min(index, 14) * 55) + 'ms');
      span.textContent = word + (index < words.length - 1 ? ' ' : '');
      heading.append(span);
    });
  });

  const wordHeadings = document.querySelectorAll('[data-word-reveal]');
  if (reduced || !('IntersectionObserver' in window)) {
    wordHeadings.forEach((heading) => heading.classList.add('is-word-visible'));
  } else {
    const wordObserver = new IntersectionObserver((entries, obs) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-word-visible'); obs.unobserve(entry.target); }
    }), { threshold: .16 });
    wordHeadings.forEach((heading) => wordObserver.observe(heading));
  }

  document.documentElement.classList.add('shycute-motion-ready');
})();